import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { classNames } from '../utils/classnames';
/**
 * 纵横比视图组件（高度随宽度的变化等比例变化）
 */
export var AspectRatioView = function AspectRatioView(props) {
  var className = props.className,
    _props$aspectRatio = props.aspectRatio,
    aspectRatio = _props$aspectRatio === void 0 ? '1/1' : _props$aspectRatio,
    children = props.children;
  var spaceStyle = useMemo(function () {
    var _String$split = String(aspectRatio).split('/'),
      _String$split2 = _slicedToArray(_String$split, 2),
      _String$split2$ = _String$split2[0],
      w = _String$split2$ === void 0 ? 1 : _String$split2$,
      _String$split2$2 = _String$split2[1],
      h = _String$split2$2 === void 0 ? 1 : _String$split2$2;
    return {
      padding: "0 0 ".concat(Number(h) / Number(w) * 100, "% 0"),
      height: 0
    };
  }, [aspectRatio]);
  return _jsx("div", Object.assign({
    className: classNames(className, 'relative'),
    style: spaceStyle
  }, {
    children: _jsx("div", Object.assign({
      className: classNames(className, 'absolute top-0 left-0 right-0 h-full'),
      style: {
        margin: '0'
      }
    }, {
      children: children
    }))
  }));
};
AspectRatioView.displayName = 'AspectRatioView';
AspectRatioView.defaultProps = {
  aspectRatio: '1/1'
};